import { render, staticRenderFns } from "./staffadd.vue?vue&type=template&id=78ac9b6e&scoped=true"
import script from "./staffadd.vue?vue&type=script&lang=js"
export * from "./staffadd.vue?vue&type=script&lang=js"
import style0 from "./staffadd.vue?vue&type=style&index=0&id=78ac9b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ac9b6e",
  null
  
)

export default component.exports